
import React from 'react';
import { HiEye, HiTrash, HiPencil, HiCheckCircle, HiXCircle } from 'react-icons/hi';
import { CiSettings } from "react-icons/ci";
import { CButton } from '@coreui/react';

const ListView = ({ children, heading, subheading, editFunc, deleteFunc, deletePEFunc, viewFunc, contentMatch, showMatch = true, setting }) => {
    return (
        <div className='card shadow-sm p-3 mb-4 list-view-card' style={{ borderRadius: "13px" }} >
            <div className='d-flex align-items-center justify-content-between'>
                <div onClick={editFunc} className="d-flex align-items-start justify-content-between">
                    <h6
                        className="card-title fw-bolder list-view-card__title"
                        style={{ position: "relative", paddingRight: "18px",marginBottom:"0px", gap: "5px" }}
                    >
                        {showMatch && (
                            <span
                                className={`ms-2 ${contentMatch ? 'text-success' : 'text-danger'}`}
                                style={{
                                    fontSize: '1rem',
                                    marginRight: "5px",
                                }}
                            >
                                {contentMatch ? <HiCheckCircle /> : <HiXCircle />}
                            </span>
                        )}
                        {heading}

                    </h6>
                    <p className="card-subtitle mb-2 text-black-50 list-view-card__subtitle">{subheading}</p>
                </div>

                <span className='d-flex gap-1 list-view-card__actions'>

                    {viewFunc && <CButton onClick={viewFunc} variant='outline' color='success' className="px-2"><HiEye size={20} /></CButton>}
                    {setting && <CButton onClick={setting} variant='outline' color='secondary' className="px-2"  > <CiSettings size={20} /></CButton>}
                    {editFunc && <CButton onClick={editFunc} variant='outline' color='warning' className="px-2" ><HiPencil size={20} /></CButton>}
                    {deleteFunc && <CButton onClick={deleteFunc} variant='outline' color='danger' className={`${contentMatch ? '' : 'disabled'} px-2`} style={{ outline: contentMatch ? '' : '1px solid red' }}  ><HiTrash size={20} /></CButton>}
                    {deletePEFunc && <CButton onClick={deletePEFunc} variant='outline' color='danger' className={`px-2`}    ><HiTrash size={20} /></CButton>}

                </span>
            </div>
            {children}
        </div>
    );
};

export default ListView;
//  class="border-danger  bg-danger p-2 text-white bg-opacity-75 border-2 rounded-1"
